import { Box, Skeleton } from "@mui/material";

function KalenderSkeliton() {
    return <div className="kalender_skeliton">
        <Box>
            <div className="sk_wrapper MO_Skeliton_Wrapper">
                <div>
                    <Skeleton animation="wave" hight="15px" width="100%" />
                </div>
                <div className="sk_dateWrapper">
                    <div>
                        <Skeleton animation="text" hight="15px" width="150px" />
                    </div>
                    <div>
                        <Skeleton animation="text" hight="15px" width="150px" />
                    </div>
                </div>
            </div>

            <div className="vSkeliton_wrapper" >
                <div style={{ width:"26%"}}><Skeleton variant="rounded" className="vSkeliton" /></div>
                <div style={{ width:"75%"}}>
                    <table>

                        <tr className="tr1">
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" /></div>
                            </td>
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                            <td className="tdl">
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                            <td className="tdl">
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                            <td>
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                            <td className="tdl">
                                <div><Skeleton variant="rounded" hight="3em" width="150px" />    </div>
                            </td>
                        </tr>


                    </table>
                </div>
            </div>

        </Box>
    </div>
}
export default KalenderSkeliton;